import { Component } from "./component"
import { handleComponentError } from "../decorators/handleComponentError"
import { FooterTextInterface } from "../types/footerText.interface"

export class FooterText extends Component<FooterTextInterface> {
    protected setText(text?: string) {
        if (text) {
            ;(this.element as HTMLParagraphElement).textContent = text
        }
    }

    protected setColor(color?: string) {
        if (color) {
            const style = document.createElement("style")

            style.innerHTML = `*{
                color: ${this.props.color} !important; margin: 0 !important;
            }`

            this.element?.shadowRoot?.appendChild(style)
        }
    }

    private replaceText(text?: string): string {
        if (!text) {
            return ""
        }

        const replacements = {
            "%b": this.props.branding,
            "%Y": new Date().getFullYear().toString()
        }

        return Object.entries(replacements).reduce(
            (prev, [key, value]) => prev?.replace(key, value as string),
            text
        )
    }

    @handleComponentError("FooterText")
    render() {
        this.setColor(this.props.color)
        this.show(!!this.props.isVisible && !!this.props.title)

        const footerText = this.replaceText(this.props.title)
        this.setText(footerText)
        super.render()
    }
}
